<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->

        <div class="widget has-shadow">
          <div class="btn-group p-3 d-flex flex-row align-content-center align-items-center">
            <div v-for="(item, index) in menue" :key="index">
              <div :id="`Menu${index}`" class="accordion-icon ml-2">
                <button v-if="type == item.name" class="btn btn-success" @click="getItems(item.name)">
                  {{ item.faName }}
                </button>
                <button v-else class="btn btn-outline-secondary" @click="getItems(item.name)">
                  {{ item.faName }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="widget has-shadow">
          <div class="widget-body">
            <p v-if="report.currentTime">
              <button class="btn btn-outline-secondary" @click="changeMonth(1)">ماه بعد</button>

              {{
                new Date(report.currentTime).getFullYear() +
                  '/' +
                  new Date(report.currentTime).toLocaleString('default', { month: 'long' })
              }}

              <button class="btn btn-outline-secondary" @click="changeMonth(-1)">ماه قبل</button>
            </p>
            <p>درآمد مستقیم: {{ report.income }}</p>
            <p>درآمد بازار: {{ report.incomeBazzar }}</p>
            <p>درآمد مایکت: {{ report.incomeMyket }}</p>
            <p>درآمد کل تیکت: {{ report.incomeFromTicket }}</p>
            <p>درآمد اشتراک: {{ report.incomeFromLicense }}</p>
            <p>سکه های خرج شده در فروشگاه: {{ report.spentCoin }}</p>
            <p>تعداد asset های خریده شده: {{ report.purchasedAssetsCount }}</p>
            <p>تعداد اشتراک های خریده شده: {{ report.purchasedLicenceCount }}</p>
          </div>
        </div>

        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام کاربری</th>
                    <th>ایمیل</th>
                    <th>شماره تماس</th>
                    <th>نوع پرداخت</th>
                    <th>زمان</th>
                    <th>{{ type === 'shop' ? 'سکه' : 'مبلغ' }}</th>
                    <th v-if="type === 'shop'">ایتم</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="purchase in purchases" :key="purchase._id">
                    <td>
                      <router-link :to="{ path: '/dashboard/user', query: { id: purchase.userId._id } }">{{
                        purchase.userId ? purchase.userId.username : 'gusst'
                      }}</router-link>
                    </td>
                    <td>{{ purchase.userId ? purchase.userId.email : '' }}</td>
                    <td>{{ purchase.userId ? purchase.userId.phone : '' }}</td>
                    <td>{{ purchaseMethods[purchase.method] }}</td>
                    <td>
                      {{ new Date(purchase.createdAt).toLocaleTimeString('fa-IR') }} -
                      {{ new Date(purchase.createdAt).toLocaleDateString('fa-IR') }}
                    </td>
                    <td>{{ purchase.price }}</td>
                    <td v-if="type === 'shop'">{{ shopItems[purchase.purchaseType] }}</td>
                    <td>
                      <button class="btn btn-gradient-01" disabled>جزییات</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <!-- disabled -->
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getReports({ page: page.pre, condition })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getReports({ page: page.next, condition })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import finantialService from '../../../../services/finantial';
export default {
  name: 'indexReport',
  data() {
    return {
      purchaseMethods: {
        coin: 'سکه',
        cash: 'مستقیم',
        gem: 'جم',
        ticket: 'تیکت',
        bazzar: 'بازار',
        myket: 'مایکت',
      },
      shopItems: {
        Avatar: 'آواتار',
        Chat: 'ایموجی',
        Formation: 'ترکیب',
        Skin: 'مهره',
      },
      menue: [
        {
          name: 'shop',
          faName: 'فروشگاه',
          selected: false,
        },
        {
          name: 'license',
          faName: 'اشتراک',
          selected: true,
        },
        {
          name: 'coin',
          faName: 'بسته سکه',
          selected: false,
        },
        {
          name: 'ticket',
          faName: 'بلیط',
          selected: false,
        },
      ],
      type: 'shop',
      purchases: [],
      report: '',
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
      condition: {},
    };
  },
  created() {
    this.getReports({ page: 1 });
  },
  methods: {
    async getReports({ page = 1, condition = { type: this.type, time: null } }) {
      if (page == '' || parseInt(page) < 1) return;
      this.condition = { ...condition, page };
      const report = await finantialService.getReport({ condition: this.condition });
      this.report = report;
      this.purchases = report.purchases;
      this.pageController(report);
    },

    changeMonth(to) {
      let date = new Date(this.report.currentTime);
      let month = new Date(date.setMonth(date.getMonth() + parseInt(to)));
      this.getReports({ page: 1, condition: { type: this.type, time: month } });
    },

    getItems(type) {
      this.type = type;
      this.getReports({ page: 1, condition: { type: this.type } });
    },

    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
  },
};
</script>
